import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://talentprism.ai/static/js/chat-widget-loader-bundle.js';
    script.async = true;
    script.setAttribute('data-team-id', '3572');
    script.setAttribute('data-token', 'dgOQNElFKIKhuIHK8q_WcyvOvvs5xnU9r2h59142BS4');
    script.setAttribute('data-auto-open', 'true');
    script.setAttribute('data-auto-open-delay-ms', '2500');
    script.setAttribute('data-auto-open-cooldown-hours', '168');
    script.setAttribute('data-auto-open-scope', 'career');
    script.setAttribute('data-page-category', 'career');
    script.setAttribute('data-welcome-title', "Hello, I'm Hannah!");
    script.setAttribute('data-welcome-body', 'I can help you with your job search, referrals, profile updates, and application questions.');
    script.setAttribute('data-widget-width', '420');
    script.setAttribute('data-widget-height', '640');
    script.setAttribute('data-launcher-size', '56');
    script.setAttribute('data-launcher-variant', 'icon');
    script.setAttribute('data-launcher-color', '#269a1d');
    script.setAttribute('data-launcher-hover-color', '#4338ca');
    script.setAttribute('data-launcher-icon-color', '#ffffff');
    script.setAttribute('data-launcher-aria-label', 'Open chat');
    script.setAttribute('data-bounce', 'false');
    script.setAttribute('data-bounce-interval-ms', '6000');
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen flex flex-col font-['Inter',sans-serif] bg-black" data-id="element-0">
      {/* Demo Alert Banner */}
      <div className="bg-indigo-600 text-white text-center py-2 px-4 text-sm font-medium z-50 relative" data-id="element-1">
        This is a demo made for Jerry by Sangy. Get in touch at{' '}
        <a href="mailto:sangy@talentprism.ai" className="underline font-semibold hover:text-indigo-200 transition-colors" data-id="element-2">
          sangy@talentprism.ai
        </a>
      </div>
      <TopBar data-id="element-3" />

      {/* Main Content Area with Background */}
      <div className="relative flex-grow flex flex-col bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1920&q=80")'
    }} data-id="element-4">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60 z-0" data-id="element-5"></div>

        <Navbar data-id="element-6" />
        <Hero data-id="element-7" />
      </div>
    </div>;
}